<template>
    <!-- Main Wrapper -->
        <div class="main-wrapper">
		
			<!-- Header -->
                <layout-header />
			<!-- /Header -->
			
			<!-- Sidebar -->
                <layout-sidebar />
			<!-- /Sidebar -->
			
			<!-- Page Wrapper -->
            <div class="page-wrapper">
			
				<!-- Page Content -->
                <div class="content container-fluid">
					
					<!-- Page Header -->
					<div class="page-header">
						<div class="row">
							<div class="col-sm-12">
								<h3 class="page-title">User Job Dashboard</h3>
								<ul class="breadcrumb">
									<li class="breadcrumb-item"><router-link to="/index">Dashboard</router-link></li>
									<li class="breadcrumb-item">Jobs</li>
									<li class="breadcrumb-item">User Dashboard</li>
									<li class="breadcrumb-item">User Dashboard</li>
								</ul>
							</div>
						</div>
					</div>
					<!-- /Page Header -->
					
					<!-- Content Starts -->
					<div class="card">
						<div class="card-body">
							<!-- <h4 class="card-title">Solid justified</h4> -->
							<ul class="nav nav-tabs nav-tabs-solid nav-justified">
								<li class="nav-item"><router-link class="nav-link active" to="/user-dashboard">Dashboard</router-link></li>
								<li class="nav-item"><router-link class="nav-link" to="/user-all-jobs">All </router-link></li>
								<li class="nav-item"><router-link class="nav-link" to="/saved-jobs">Saved</router-link></li>
								<li class="nav-item"><router-link class="nav-link" to="/applied-jobs">Applied</router-link></li>
								<li class="nav-item"><router-link class="nav-link" to="/interviewing">Interviewing</router-link></li>
								<li class="nav-item"><router-link class="nav-link" to="/offered-jobs">Offered</router-link></li>
								<li class="nav-item"><router-link class="nav-link" to="/visited-jobs">Visitied </router-link></li>
								<li class="nav-item"><router-link class="nav-link" to="/archived-jobs">Archived </router-link></li>
							</ul>
						</div>
					</div>
					
					<div class="row">
						<div class="col-md-6 col-sm-6 col-lg-6 col-xl-3">
							<div class="card dash-widget">
								<div class="card-body">
									<span class="dash-widget-icon"><i class="fa fa-file-text-o"></i></span>
									<div class="dash-widget-info">
										<h3>110</h3>
										<span>Offered</span>
									</div>
								</div>
							</div>
						</div>
						<div class="col-md-6 col-sm-6 col-lg-6 col-xl-3">
							<div class="card dash-widget">
								<div class="card-body">
									<span class="dash-widget-icon"><i class="fa fa-clipboard"></i></span>
									<div class="dash-widget-info">
										<h3>40</h3>
										<span>Applied</span>
									</div>
								</div>
							</div>
						</div>
						<div class="col-md-6 col-sm-6 col-lg-6 col-xl-3">
							<div class="card dash-widget">
								<div class="card-body">
									<span class="dash-widget-icon"><i class="fa fa-retweet"></i></span>
									<div class="dash-widget-info">
										<h3>374</h3>
										<span>Visited</span>
									</div>
								</div>
							</div>
						</div>
						<div class="col-md-6 col-sm-6 col-lg-6 col-xl-3">
							<div class="card dash-widget">
								<div class="card-body">
									<span class="dash-widget-icon"><i class="fa fa-floppy-o"></i></span>
									<div class="dash-widget-info">
										<h3>220</h3>
										<span>Saved</span>
									</div>
								</div>
							</div>
						</div>
					</div>
								
					<div class="row">
						<div class="col-md-12">
							<div class="row">
								<div class="col-md-6 text-center d-flex">
									<div class="card flex-fill">
										<div class="card-body">
											<h3 class="card-title">Overview</h3>
											<div id="line-chart" style="width:auto !important"></div>
										</div>
									</div>
								</div>
								<div class="col-md-6 d-flex">
									<div class="card flex-fill">
										<div class="card-body">
											<h3 class="card-title text-center">Latest Jobs</h3>
											<ul class="list-group">
											  	<li class="list-group-item list-group-item-action">UI Developer <span class="float-right text-sm text-muted">1 Hours ago</span></li>
											  	<li class="list-group-item list-group-item-action">Android Developer <span class="float-right text-sm text-muted">1 Days ago</span></li>
											  	<li class="list-group-item list-group-item-action">IOS Developer<span class="float-right text-sm text-muted">2 Days ago</span></li>
											  	<li class="list-group-item list-group-item-action">PHP Developer<span class="float-right text-sm text-muted">3 Days ago</span></li>
											  	<li class="list-group-item list-group-item-action">UI Developer<span class="float-right text-sm text-muted">3 Days ago</span></li>
											  	<li class="list-group-item list-group-item-action">PHP Developer<span class="float-right text-sm text-muted">4 Days ago</span></li>
											  	<li class="list-group-item list-group-item-action">UI Developer<span class="float-right text-sm text-muted">4 Days ago</span></li>
											  	<li class="list-group-item list-group-item-action">Android Developer<span class="float-right text-sm text-muted">6 Days ago</span></li>
											</ul>
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>

						
					<div class="row">
						<div class="col-md-12">
							<div class="card card-table">
								<div class="card-header">
									<h3 class="card-title mb-0">Offered Jobs</h3>
								</div>
								<div class="card-body">
									<div class="table-responsive">
										<table class="table table-nowrap custom-table mb-0">
											<thead>
												<tr>
													<th>#</th>
													<th>Job Title</th>
													<th>Department</th>
													<th class="text-center">Job Type</th>
													<th class="text-center">Actions</th>
												</tr>
											</thead>
											<tbody>
												<tr>
													<td>1</td>
													<td><router-link to="/jobdetails">Web Developer</router-link></td>
													<td>Development</td>
													<td class="text-center">
														<div class="action-label">
															<a class="btn btn-white btn-sm btn-rounded" href="#" data-toggle="dropdown" aria-expanded="false">
																<i class="fa fa-dot-circle-o text-danger"></i> Full Time
															</a>
														</div>
													</td>
													<td class="text-center">
														<a href="#" class="btn btn-sm btn-info download-offer"><span><i class="fa fa-download mr-1"></i> Download Offer</span></a>
													</td>
												</tr>
												<tr>
													<td>2</td>
													<td><router-link to="/jobdetails">Web Designer</router-link></td>
													<td>Designing</td>
													<td class="text-center">
														<div class="action-label">
															<a class="btn btn-white btn-sm btn-rounded" href="#" data-toggle="dropdown" aria-expanded="false">
																<i class="fa fa-dot-circle-o text-success"></i> Part Time
															</a>
														</div>
													</td>
													<td class="text-center">
														<a href="#" class="btn btn-sm btn-info download-offer"><span><i class="fa fa-download mr-1"></i> Download Offer</span></a>
													</td>
												</tr>
												<tr>
													<td>3</td>
													<td><router-link to="/jobdetails">Android Developer</router-link></td>
													<td>Android</td>
													<td class="text-center">
														<div class="action-label">
															<a class="btn btn-white btn-sm btn-rounded" href="#" data-toggle="dropdown" aria-expanded="false">
																<i class="fa fa-dot-circle-o text-danger"></i> Internship
															</a>
														</div>
													</td>
													<td class="text-center">
														<a href="#" class="btn btn-sm btn-info download-offer"><span><i class="fa fa-download mr-1"></i> Download Offer</span></a>
													</td>
												</tr>
											</tbody>
										</table>
									</div>
								</div>
							</div>
						</div>
					</div>
			
												
					<div class="row">
						<div class="col-md-12">
							<div class="card card-table">
								<div class="card-header">
									<h3 class="card-title mb-0">Applied Jobs</h3>
								</div>
								<div class="card-body">
									<div class="table-responsive">
										<table class="table table-nowrap custom-table mb-0">
											<thead>
												<tr>
													<th>#</th>
													<th>Job Title</th>
													<th>Department</th>
													<th>Start Date</th>
													<th>Expire Date</th>
													<th class="text-center">Job Type</th>
													<th class="text-center">Status</th>
													<th class="text-center">Actions</th>
												</tr>
											</thead>
											<tbody>
												<tr>
													<td>1</td>
													<td><router-link to="/jobdetails">Web Developer</router-link></td>
													<td>Development</td>
													<td>3 Mar 2019</td>
													<td>31 May 2019</td>
													<td class="text-center">
														<div class="action-label">
															<a class="btn btn-white btn-sm btn-rounded" href="#" data-toggle="dropdown" aria-expanded="false">
																<i class="fa fa-dot-circle-o text-danger"></i> Full Time
															</a>
														</div>
													</td>
													<td class="text-center">
														<div class="action-label">
															<a class="btn btn-white btn-sm btn-rounded" href="#" data-toggle="dropdown" aria-expanded="false">
																<i class="fa fa-dot-circle-o text-danger"></i> Open
															</a>
														</div>
													</td>
													<td class="text-center">
														<div class="dropdown dropdown-action">
															<a href="#" class="action-icon dropdown-toggle" data-toggle="dropdown" aria-expanded="false"><i class="material-icons">more_vert</i></a>
															<div class="dropdown-menu dropdown-menu-right">
																<a class="dropdown-item" href="#" data-toggle="modal" data-target="#delete_employee"><i class="fa fa-trash-o m-r-5"></i> Delete</a>
															</div>
														</div>
													</td>
												</tr>
												<tr>
													<td>2</td>
													<td><router-link to="/jobdetails">Web Designer</router-link></td>
													<td>Designing</td>
													<td>3 Mar 2019</td>
													<td>31 May 2019</td>
													<td class="text-center">
														<div class="action-label">
															<a class="btn btn-white btn-sm btn-rounded" href="#" data-toggle="dropdown" aria-expanded="false">
																<i class="fa fa-dot-circle-o text-success"></i> Part Time
															</a>
														</div>
													</td>
													<td class="text-center">
														<div class="action-label">
															<a class="btn btn-white btn-sm btn-rounded" href="#" data-toggle="dropdown" aria-expanded="false">
																<i class="fa fa-dot-circle-o text-success"></i> Closed
															</a>
														</div>
													</td>
													<td class="text-center">
														<div class="dropdown dropdown-action">
															<a href="#" class="action-icon dropdown-toggle" data-toggle="dropdown" aria-expanded="false"><i class="material-icons">more_vert</i></a>
															<div class="dropdown-menu dropdown-menu-right">
																<a class="dropdown-item" href="#" data-toggle="modal" data-target="#delete_employee"><i class="fa fa-trash-o m-r-5"></i> Delete</a>
															</div>
														</div>
													</td>
												</tr>
												<tr>
													<td>3</td>
													<td><router-link to="/jobdetails">Android Developer</router-link></td>
													<td>Android</td>
													<td>3 Mar 2019</td>
													<td>31 May 2019</td>
													<td class="text-center">
														<div class="action-label">
															<a class="btn btn-white btn-sm btn-rounded" href="#" data-toggle="dropdown" aria-expanded="false">
																<i class="fa fa-dot-circle-o text-danger"></i> Internship
															</a>
														</div>
													</td>
													<td class="text-center">
														<div class="action-label">
															<a class="btn btn-white btn-sm btn-rounded" href="#" data-toggle="dropdown" aria-expanded="false">
																<i class="fa fa-dot-circle-o text-danger"></i> Cancelled
															</a>
														</div>
													</td>
													<td class="text-center">
														<div class="dropdown dropdown-action">
															<a href="#" class="action-icon dropdown-toggle" data-toggle="dropdown" aria-expanded="false"><i class="material-icons">more_vert</i></a>
															<div class="dropdown-menu dropdown-menu-right">
																<a class="dropdown-item" href="#" data-toggle="modal" data-target="#delete_employee"><i class="fa fa-trash-o m-r-5"></i> Delete</a>
															</div>
														</div>
													</td>
												</tr>
											</tbody>
										</table>
									</div>
								</div>
							</div>
						</div>
					</div>
				
					<!-- /Content End -->
					
                </div>
				<!-- /Page Content -->
				
            </div>
			<!-- /Page Wrapper -->
			
        </div>
		<!-- /Main Wrapper -->
</template>

<script>
  export default {
    mounted() {
      $(document).ready(function () {
        lineChart();
        $(window).resize(function () {
          window.lineChart.redraw();
        });
      });
      function lineChart() {
        window.lineChart = Morris.Line({
          element: 'line-chart',
          data: [
       { y: "2006", a: 20, b: 2, c:1 },
      { y: "2007", a: 10, b: 2, c:3 },
      { y: "2008", a: 5, b: 3, c:6 },
      { y: "2009", a: 5, b: 4, c:8 },
      { y: "2010", a: 20, b: 1, c:10 },
          ],
          xkey: 'y',
          ykeys: ["a", "b","c"],
          labels: ["UI Developer", "Android", "Web Designing"],
          lineColors: ['#373651','#E65A26','#a1a1a1'],
          lineWidth: '3px',
          resize: true,
          redraw: true
        });
      }
    },
  }
</Script>


// WEBPACK FOOTER //
// src/components/userdashboard.vue